import React from 'react';
import { AppRouter } from './routers/appRouter';
import { I18Provider, LOCALES } from './i18n';
import { FormattedMessage } from 'react-intl';
export const GizApp = () => {
    return (
        <I18Provider locale={LOCALES.SPANISH}>
            <div style={{"min-height":"100vh","background-color":"#002E0F","overflow":"hidden"}}>
            <AppRouter />
            </div>
        </I18Provider>
        
    );
}